"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function catalogCodeForId(items, id) {
    var foundItem = items.find(function (item) { return item.id === id; });
    if (foundItem) {
        return foundItem.code;
    }
    return '';
}
exports.default = catalogCodeForId;
//# sourceMappingURL=catalogCodeForId.js.map